import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/mail.service";
import {
  IGetMailConversationsParams,
  ISendMailMessageParams,
  ISendMailFilesParams,
  IGetMailStatsParams,
} from "../../models/mail.model";

export const getMailConversationsThunk = createAsyncThunk(
  "mail/getConversations",
  async (params: IGetMailConversationsParams, { rejectWithValue }) => {
    try {
      const response = await api.getMailConversations(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get mail conversations failed"
      );
    }
  }
);

export const getMailConversationByIdThunk = createAsyncThunk(
  "mail/getConversationById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await api.getMailConversationById(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get mail conversation failed"
      );
    }
  }
);

export const sendMailMessageThunk = createAsyncThunk(
  "mail/sendMessage",
  async (params: ISendMailMessageParams, { rejectWithValue }) => {
    try {
      const response = await api.sendMailMessage(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Send mail message failed"
      );
    }
  }
);

export const sendMailFilesThunk = createAsyncThunk(
  "mail/sendFiles",
  async (params: ISendMailFilesParams, { rejectWithValue }) => {
    try {
      const response = await api.sendMailFiles(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Send mail files failed"
      );
    }
  }
);

export const updateMailConversationStatusThunk = createAsyncThunk(
  "mail/updateStatus",
  async (
    { id, status }: { id: string; status: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.updateMailConversationStatus(id, status);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Update mail conversation status failed"
      );
    }
  }
);

export const getMailStatsThunk = createAsyncThunk(
  "mail/getStats",
  async (params: IGetMailStatsParams, { rejectWithValue }) => {
    try {
      const response = await api.getMailStats(params);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get mail stats failed"
      );
    }
  }
);
